import React from 'react';
import {useFormContext} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {RadioGroupQuestion} from "../../../../widgets/inputs/RadioGroupQuestion";

export const RischioGrid = ({isCit = false}) => {
	const {errors, control} = useFormContext();
	
	return (
		<React.Fragment>
			
			{/*<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? languages[appContext.state.lang].RISCHIO_SCARICATO_APP : SCARICATO_IMMUNI_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"scaricataAppImmuni"}
					error={errors["scaricataAppImmuni"]}
				/>
			</Grid>
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? languages[appContext.state.lang].RISCHIO_VIAGGI_ESTERO : VIAGGI_ESTERO_14GG_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"viaggiato14gg"}
					error={errors["viaggiato14gg"]}
				/>
			</Grid>
			{
				watch("viaggiato14gg") === "true" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<CustomAutoComplete
						label={LISTA_PAESI_ESTERI}
						control={control}
						options={countryList}
						multiple={true}
						rules={autocompleteRules}
						name={"paesiEsteri"}
						error={errors["paesiEsteri"]}
					/>
				</Grid>
			}
			
			<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? languages[appContext.state.lang].RISCHIO_VIAGGI_REGION : VIAGGI_REGIONI_14GG_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"regioni14gg"}
					error={errors["regioni14gg"]}
				/>
			</Grid>
			{
				watch("regioni14gg") === "true" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<CustomAutoComplete
						label={LISTA_REGIONI_VISITATE}
						control={control}
						options={regioniItaliane}
						multiple={true}
						rules={autocompleteRules}
						name={"regioniVisitate"}
						error={errors["regioniVisitate"]}
					/>
				</Grid>
			}
			*/}
			{/*<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? ESPOSTO_RISCHIO_1a : ESPOSTO_RISCHIO_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"possibileEspRischio"}
					error={errors["possibileEspRischio"]}
				/>
			</Grid>
			{
				watch("possibileEspRischio") === "true" &&
				<React.Fragment>
					<Grid item xs={12} className={monitorClasses.subQuestion}>
						<ChechBoxMultiQuestion
							question={""}
							control={control}
							list={rischiEsposizione}
						/>
					</Grid>
				</React.Fragment>
			}*/}
			{/*<Grid item xs={12}>
				<RadioGroupQuestion
					question={isCit ? VIVI_SOLO_1a : VIVI_SOLO_3a}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"viviDaSolo"}
					error={errors["viviDaSolo"]}
				/>
			</Grid>
			{
				watch("viviDaSolo") === "false" &&
				<Grid item xs={12} className={monitorClasses.subQuestion}>
					<RadioGroupQuestion
						question={isCit ? CORRETTO_ISOLAMENTO_1a : CORRETTO_ISOLAMENTO_3a}
						control={control}
						autoFocus={true}
						defaultValue={""}
						rules={{required: true}}
						name={"correttoIsolamento"}
						error={errors["correttoIsolamento"]}
					/>
				</Grid>
			}*/}
			{/*{
				watch("correttoIsolamento") === "true" &&
				<Grid item xs={12} className={
					watch("correttoIsolamento") === "true" && checkParametri(watch) ?
						monitorClasses.subSubQuestionStart : monitorClasses.subSubQuestion
				}>
					<ChechBoxMultiQuestion
						question={""}
						control={control}
						list={isCasoIndice ? listaParamIsolamentoCI : listaParamIsolamento}
					/>
				</Grid>
			}
			{
				watch("correttoIsolamento") === "true" && checkParametri(watch) &&
				<Grid item xs={12} className={monitorClasses.subSubQuestionEnd}>
					<CustomDateInput
						label={DATA_INIZIO_ISOLAMENTO}
						control={control}
						defaultValue={null}
						maxDate={new Date()}
						rules={{required: true}}
						name={"dataInizioIsolamento"}
						error={errors["dataInizioIsolamento"]}
					/>
				</Grid>
			}*/}
			
			{isCit && <Grid item xs={12}>
				<RadioGroupQuestion
					question={"Qualcuno dei tuoi contatti conviventi presenta sintomi?"}
					control={control}
					autoFocus={true}
					defaultValue={""}
					rules={{required: true}}
					name={"conviventiSintomi"}
					error={errors["conviventiSintomi"]}
				/>
			</Grid>}
		
		</React.Fragment>
	);
};
